import React from 'react';
import { Box } from '@mui/material';
import type { Planner } from './usePlanner';

export const FilterChips: React.FC<{ fuels: string[]; planner: Planner }> = ({
  fuels,
  planner,
}) => {
  const chips = ['ALL', ...fuels];
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '4px',
        p: '4px',
        bgcolor: 'rgba(226,232,240,0.5)',
        borderRadius: '8px',
        mx: 1.5,
        mb: 1,
      }}
    >
      {chips.map(c => {
        const active = planner.filter === c;
        const label = c === 'ALL' ? 'All' : c === 'NONE' ? 'DF/CDF' : c.charAt(0) + c.slice(1).toLowerCase();
        return (
          <button
            key={c}
            onClick={() => planner.setFilter(c)}
            style={{
              flex: 1,
              height: 28,
              borderRadius: 6,
              fontSize: '0.7rem',
              fontWeight: 700,
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.15s',
              background: active ? 'white' : 'transparent',
              color: active ? '#003366' : '#64748b',
              boxShadow: active ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
            }}
          >
            {label}
          </button>
        );
      })}
    </Box>
  );
};
